import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from "./classes/BaseService";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class DetailDataService extends BaseService {

  apiUrl: string = "DetailData.php?";

  constructor(protected http: HttpClient) {
    super(http);
  }

  getDetailData(store: string, country: string, itemType: string, idInStore: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("store", store),
      new UrlParam("country", country),
      new UrlParam("itemType", itemType),
      new UrlParam("idInStore", idInStore)
    );

    return this.get(url);
  }

}
